<template>
    <div class="filter_block">
        <div class="form-group js-stools-container-filters mb-4">
            <div class="d-flex flex-wrap ">
                <div class="flex-fill mt-2 mb-2 pr-4">
                    <div class="load_select color-primary" v-if="is_load">
                        <sync-loader :loading="true" color="#53644B" size="5px"></sync-loader>
                    </div>
                    
                    <v-select v-else
                              class="imc_reasons"
                              label="name"
                              placeholder=" Оберіть Організацію"
                              id="id"
                              v-model="org_id"
                              @input="emit_filter"
                              :reduce="item => item.id"
                              :options="organizations"
                              :filterable="true"
                    
                    >
                        <template slot="no-options">
                            Оберіть Організацію
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.name }}
                                <small>{{ option.edrpou }}</small>
                            </div>
                        </template>
                    </v-select>
                </div>
                
                <div class="flex-fill mt-2 mb-2 pr-4">
                    <div class="load_select color-primary" v-if="is_load">
                        <sync-loader :loading="true" color="#53644B" size="5px"></sync-loader>
                    </div>
                    
                    <v-select
                        v-else
                        class="imc_reasons"
                        label="name"
                        id="id"
                        @input="emit_filter"
                        v-model="user_id"
                        :reduce="item => item.id"
                        :options="users"
                        :filterable="true"
                        placeholder="Оберіть Користувача"
                    >
                        <template slot="no-options">
                            Оберіть Користувача
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.name }}
                            </div>
                        </template>
                    </v-select>
                </div>
            
                <vacation_modal></vacation_modal>
                
            </div>
        </div>
    
    </div>
</template>

<script>

import vSelect from 'vue-select';
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import Vacation_modal from "./vacation_modal.vue";

export default {
    name: "vacation_filter",
    components: {
        Vacation_modal,
        vSelect,
        SyncLoader,
    },
    data() {
        return {
            is_load: false,
            organizations: [],
            users: [],
            
            org_id: null,
            user_id: null,
        }
    },
    created() {
        this.load_filters();
    },
    
    methods: {
        
        emit_filter(param) {
            console.log('set_filter', param);
            VACATIONCALENDAR.update(this.org_id, this.user_id)
        },
        
        async load_filters() {
            this.is_load = true;
            
            this.organizations = [];
            this.users = [];
            
            await api.get('/calendar/vacations/filter', {}).then(({data}) => {
                this.is_load = false;
                if (data.status == "operation_success") {
                    let resp = data.data;
                    if (resp.hasOwnProperty('organizations')) {
                        resp.organizations.map(item => {
                            this.organizations.push(item);
                        })
                    }
                    
                    if (resp.hasOwnProperty("users")) {
                        resp.users.map(item => {
                            this.users.push(item);
                        })
                    }
                }
            }).catch(err => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
    }
}
</script>


<style scoped>

</style>